import { getDocumentBySlug, getPrevNextDocument } from "$lib/navigation/navigation";
import { NavigationInfo } from "$lib/state/models/navigation-info.svelte";

export const prerender = true;
export const ssr = true;
export const trailingSlash = "always";

export const load = async ({ data }) => {
	if (!data) return {};

	const groups = data.groups;
	const slug = data.slug;
	const document = getDocumentBySlug(groups, slug);

	const prevNext = getPrevNextDocument(groups, slug);
	const prevLink = prevNext.prev ? new NavigationInfo(prevNext.prev.title, prevNext.prev.path) : null;
	const nextLink = prevNext.next ? new NavigationInfo(prevNext.next.title, prevNext.next.path) : null;

	return {
		slug: data.slug,
		groups: data.groups,
		document: document,
		prevLink: prevLink,
		nextLink: nextLink,
		canonical: data.canonical,
	};
};
